import CSS from 'csstype';

import { IClientProject } from '~/providers/client-interfaces';
import { IAdminProject } from '~/providers/admin-interfaces';
import { TTrans } from "~/hooks/useTrans";

export interface IBreadcrumbItem {
	type: "text" | "separator";
	value?: string;
	className?: string;
	style?: CSS.Properties;
}

function getInternalTitle(trans: TTrans): IBreadcrumbItem {
	return {
		value: trans("administration"),
		type: "text",
	};
}

function getProjectTitle(trans: TTrans, project: IClientProject | IAdminProject, setBold?: boolean): IBreadcrumbItem {
	if (project) {
		return {
			type: "text",
			value: [
				...project.userTitle? [project.userTitle] : [],
				`(${project.internalName})`,
			].join(" "),
			...setBold
				? {
					style: { fontWeight: "bold" },
				}
				: {},
		};
	}

	return {
		type: "text",
		value: trans("loading"),
	};
}

export function getProjectBreadcrumb(trans: TTrans, isInternal: boolean, projectData: IClientProject | IAdminProject, section: string | Array<string>) {
	const sections: Array<IBreadcrumbItem> = (Array.isArray(section) ? section : [section]).map(value => ({
		type: "text",
		value,
	}));
	const textValues: Array<IBreadcrumbItem> = [
		...isInternal
			? [
				getInternalTitle(trans),
			]
			: [],
		{ type: "text", value: trans("projects") },
		getProjectTitle(trans, projectData, true),
		...sections,
	];
	const items: Array<IBreadcrumbItem> = [];

	textValues.forEach((item, ind) => {
		const isLast = ind === textValues.length - 1;

		items.push({
			...item,
			...isLast
				? {
					className: "active",
				}
				: {},
		} as IBreadcrumbItem);
		!isLast && items.push({ type: "separator" });
	});

	return items;
}

export function itemsToRenderItems(origItems: Array<string>) {
	const output: Array<IBreadcrumbItem> = [];

	for (let ind = 0, max = origItems.length; ind < max; ind++) {
		output.push({
			value: origItems[ind],
			type: "text",
			className: ind === max - 1 ? "active" : "",
		});

		if (ind < max - 1) {
			output.push({
				type: "separator",
			});
		}
	}

	return output;
}
